import axios from "axios";
import { loginreq, req,reqGet} from "../axiosFun";

// 查询队伍最大金额限制详情
export const getTeamLimitInfo = params => {
    return reqGet("get", "/app-yijiu-backstage/getTeamLimitInfo", params);
};

// 删除队伍最大金额限制
export const deleteTeamLimit = params => {
    return reqGet("get", "/app-yijiu-backstage/deleteTeamLimit", params);
  };

// 添加队伍最大金额限制  
export const addTeamLimit = params => {
    return req("post", "/app-yijiu-backstage/addTeamLimit", params);
};

// 修改队伍最大金额限制  
export const updateTeamLimit = params => {
    return req("post", "/app-yijiu-backstage/updateTeamLimit", params);
};
  


// WEBPACK FOOTER //
// ./src/api/manage/teamlimit.js